import { render, staticRenderFns } from "./SwatchesCarousel.vue?vue&type=template&id=2911bc65"
import script from "./SwatchesCarousel.vue?vue&type=script&lang=js"
export * from "./SwatchesCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports